import { Tabs as TabsPrimitive } from '@base-ui/react/tabs';

import { cn } from '@/lib/utils';

export type TabsProps = TabsPrimitive.Root.Props;

const Tabs = ({ className, orientation = 'horizontal', ...props }: TabsProps) => {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      data-orientation={orientation}
      className={cn('group/tabs flex gap-2 data-horizontal:flex-col', className)}
      {...props}
    />
  );
};

export default Tabs;
